import { combineReducers } from "@reduxjs/toolkit";
import {
  allSubscriptionReducer,
  subscribeReducer,
  totalSubscriberReducer,
  unsubscribeReducer,
  isSubscribedReducer,
} from "./slices";

const subscriptionReducer = combineReducers({
  allSubscription: allSubscriptionReducer,
  unsubscribe: unsubscribeReducer,
  subscribe: subscribeReducer,
  totalSubscriber: totalSubscriberReducer,
  isSubscribed: isSubscribedReducer,
});

export default subscriptionReducer;
